import React from 'react';
import styled from 'styled-components';
import { TextField } from '@material-ui/core';

import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardAttributeDb } from '../redux/cardAttributeDbSlice';
import { CardShapeDb } from '../redux/cardShapeDbSlice';
import { UiCardItemDb } from '../redux/uiCardItemDbSlice';
import { deepCopy } from '../general';

const ItemField = styled(TextField)`
  width: 99%;
`

type ItemNameInputProps = {
  item: CardTemplateAttributeDb | CardTemplateShapeDb | CardAttributeDb | CardShapeDb | UiCardItemDb;
  changeItem: (item: any) => void;
}
const ItemNameInput: React.FC<ItemNameInputProps> = ({item, changeItem}) => {
  const changeValue = (newValue: string) => {
    const newItem = deepCopy(item);
    newItem.name = newValue;
    changeItem(newItem);
  }

  return (
    <ItemField variant='outlined'
      label='項目名'
      value={item.name}
      onChange={(ev) => {changeValue(ev.target.value)}} 
    />
  );
}

export default ItemNameInput;
